import { render } from "./app-alert-error-action.vue?vue&type=template&id=9453064c"
import script from "./app-alert-error-action.vue?vue&type=script&lang=js"
export * from "./app-alert-error-action.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/alert/app-alert-error-action.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9453064c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9453064c', __exports__)) {
    console.log('reload')
    api.reload('9453064c', __exports__)
  }
  
  module.hot.accept("./app-alert-error-action.vue?vue&type=template&id=9453064c", () => {
    console.log('re-render')
    api.rerender('9453064c', render)
  })

}


export default __exports__